export default __webpack_public_path__ + "static/session-7fe47fe00005a75ed0d2dbbf59b8b637.png";